import { ref, watch } from 'vue';
import axios from 'axios';

const DEFAULT_CURRENCY = { code: 'EUR', value: 1, symbol: 'EUR' };
const CURRENCIES_API = process.env.VUE_APP_API + 'currencies';
const LOCAL_KEY = 'currency';

const currencies = ref([DEFAULT_CURRENCY]);
const currentCurrency = ref(DEFAULT_CURRENCY);
const isLoaded = ref(false);

function validateCurrency(code) {
  return currencies.value.find(c => c.code === code);
}

function setCurrency(code) {
  const found = validateCurrency(code);
  if (found) {
    currentCurrency.value = found;
    localStorage.setItem(LOCAL_KEY, found.code);
  } else {
    currentCurrency.value = currencies.value[0] || DEFAULT_CURRENCY;
    localStorage.setItem(LOCAL_KEY, currentCurrency.value.code);
  }
}

async function fetchCurrencies($http) {
  try {
    const http = $http || axios;
    const res = await http.get(CURRENCIES_API);
    if (res.data.status === 'OK' && Array.isArray(res.data.payload) && res.data.payload.length) {
      currencies.value = res.data.payload.map(c => ({
        code: c.code,
        value: c.value,
        symbol: c.symbol || c.code
      }));
      // Validate localStorage
      const saved = localStorage.getItem(LOCAL_KEY);
      setCurrency(saved && validateCurrency(saved) ? saved : currencies.value[0].code);
    } else {
      currencies.value = [DEFAULT_CURRENCY];
      setCurrency(DEFAULT_CURRENCY.code);
    }
  } catch {
    currencies.value = [DEFAULT_CURRENCY];
    setCurrency(DEFAULT_CURRENCY.code);
  }
  isLoaded.value = true;
}

function getCurrencySymbol() {
  return currentCurrency.value.symbol || currentCurrency.value.code;
}

function getCurrencyCode() {
  return currentCurrency.value.code;
}

function onCurrencyChange(cb) {
  return watch(currentCurrency, cb);
}

export default function useCurrency($http) {
  return {
    currencies,
    currentCurrency,
    isLoaded,
    setCurrency,
    getCurrencySymbol,
    getCurrencyCode,
    onCurrencyChange,
    fetchCurrencies: () => fetchCurrencies($http)
  };
}
